import React from "react";
import { FaStar, FaCheckCircle, FaQuoteLeft } from "react-icons/fa";
import SectionHeader from "./SectionHeader";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

import api from "../services/api";

const CustomerReviews = () => {
  const [reviews, setReviews] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await api.get("/reviews");
        if (response.data && response.data.length > 0) {
          setReviews(response.data);
        }
      } catch (error) {
        console.error("Error fetching reviews:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchReviews();
  }, []);

  if (loading) return null; // Or a skeleton loader
  if (reviews.length === 0) return null;

  return (
    <section
      className="bg-slate-50 dark:bg-slate-950 pt-8 md:pt-14 overflow-hidden relative transition-colors duration-500"
      id="reviews"
    >
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-blue-100 dark:bg-blue-900 rounded-full blur-3xl opacity-30 dark:opacity-10 -mr-32 -mt-32 transition-colors"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-blue-100 dark:bg-blue-900 rounded-full blur-3xl opacity-30 -ml-32 -mb-32 transition-colors"></div>

      <div className="max-w-7xl mx-auto px-4 relative z-10">
        <SectionHeader
          title="REVIEW KHÁCH HÀNG"
          subtitle="Trải nghiệm thực tế"
          accentColor="blue"
        />

        <div className="review-swiper-container pb-6 sm:pb-12">
          <Swiper
            modules={[Autoplay, Pagination]}
            spaceBetween={24}
            slidesPerView={1}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: true,
              dynamicBullets: true,
            }}
            breakpoints={{
              768: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 3,
              },
            }}
            className="w-full"
          >
            {reviews.map((review) => (
              <SwiperSlide key={review.id} className="py-2">
                <div className="bg-white dark:bg-slate-900 p-4 md:p-8 rounded-2xl shadow-[0_15px_40px_rgba(0,0,0,0.05)] dark:shadow-[0_15px_40px_rgba(0,0,0,0.2)] border border-slate-100 dark:border-slate-800 h-full flex flex-col relative group min-h-[180px] md:min-h-[320px]">
                  <FaQuoteLeft className="absolute top-4 right-6 text-blue-500/10 dark:text-blue-400/10 text-3xl md:text-6xl" />

                  <div className="flex items-center gap-4 mb-6">
                    <div className="relative">
                      <img
                        src={review.avatar || "https://via.placeholder.com/150"}
                        alt={review.name}
                        className="w-10 h-10 md:w-16 md:h-16 rounded-full object-cover border-2 border-white dark:border-slate-800 shadow-md"
                      />
                      {review.verified && (
                        <div className="absolute -bottom-1 -right-1 bg-green-500 text-white rounded-full p-1 border-2 border-white dark:border-slate-800">
                          <FaCheckCircle className="text-[10px]" />
                        </div>
                      )}
                    </div>
                    <div>
                      <h3 className="font-black text-slate-900 dark:text-white text-base md:text-lg leading-none mb-1 text-left transition-colors">
                        {review.name}
                      </h3>
                      <div className="flex text-yellow-400 text-xs md:text-sm gap-1">
                        {[...Array(5)].map((_, i) => (
                          <FaStar
                            key={i}
                            className={
                              i < review.rating
                                ? "fill-current"
                                : "text-slate-200"
                            }
                          />
                        ))}
                      </div>
                    </div>
                  </div>

                  <p className="text-slate-600 dark:text-slate-400 text-[11px] md:text-lg italic leading-relaxed mb-4 flex-grow text-left transition-colors font-medium">
                    "{review.comment || review.text}"
                  </p>

                  <div className="pt-6 border-t border-slate-50 dark:border-slate-800 flex justify-between items-center bg-transparent transition-colors">
                    <span className="text-[10px] md:text-xs font-bold tracking-widest text-blue-600 dark:text-blue-400 uppercase transition-colors">
                      Verified Purchase
                    </span>
                    <span className="text-[10px] md:text-xs text-slate-400 dark:text-slate-500 transition-colors">
                      {review.date}
                    </span>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>

      <style>{`
        .review-swiper-container .swiper-pagination-bullet {
          background: #3b82f6 !important;
          opacity: 0.3;
        }
        .review-swiper-container .swiper-pagination-bullet-active {
          opacity: 1;
          width: 20px;
          border-radius: 5px;
        }
        .review-swiper-container .swiper-slide {
          height: auto !important;
          display: flex;
        }
      `}</style>
    </section>
  );
};

export default CustomerReviews;
